import { render, staticRenderFns } from "./HuePanel.vue?vue&type=template&id=70c57140&scoped=true&"
import script from "./HuePanel.vue?vue&type=script&lang=js&"
export * from "./HuePanel.vue?vue&type=script&lang=js&"
import style0 from "./HuePanel.vue?vue&type=style&index=0&id=70c57140&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c57140",
  null
  
)

export default component.exports